import { Notification } from './notification.model';

export interface NotificationState {
  notifications: Notification[] | null;
  error: string;
  loader: boolean;
}

export const initialState: NotificationState = {
  notifications: null,
  error: null,
  loader: false,
};
